<h3>
    <a ui-sref="admin$WorkflowConfig.general({workflowConfigId: item.Id})" ng-click="itemClick($event)">{{item.WorkflowName}}<span ng-if="!item.Active"> {{'centuriList.inactive'|translate}}</span></a>
</h3>
<p>
    {{item.WorkflowDescription}}
</p>